/*
 * Copyright (c) 2020. American Express Company
 */

// theirs
import React, { Component, ReactComponentElement } from 'react';

// ours
import { Collapsible, CollapsibleHeading, Hint, Label, SlideStepper } from '@americanexpress/dls-react';

// styles
import './BwSlider.scss';
import EditableField from 'src/bw/editable-field/EditableField';
import FormatService from '../../services/format.service';
import Selectors from 'src/utils/selectors';

export default class BwSlider extends Component<any> {
    private changeTimer: number = 0;

    public override state = {
        hideSlider: false
    };

    public override render(): ReactComponentElement<any> {
        return (
            <div className={`${this.props.className} bwSlider`}>
                {this.props.label && !this.props.hideLabel && <Label htmlFor={this.props.id}>{this.props.label}</Label>}
                {this.props.hintText && <Hint>{this.props.hintText}</Hint>}
                {this.state.hideSlider ? (
                    <EditableField
                        id={`${this.props.id}-input`}
                        value={FormatService.formatString(this.props.value)}
                        editValue={this.props.value}
                        handleSave={(value: any) => this.props.onChange(value)}
                        currencyAdornment={!this.props.isPercentage}
                        percentageAdornment={this.props.isPercentage}
                        showFractions={!!this.props.isPercentage}
                    />
                ) : (
                    <SlideStepper
                        theme={{ paddingBottom: '50px' }}
                        id={this.props.id}
                        label={this.props.label}
                        max={this.props.max}
                        min={this.props.min}
                        step={this.props.step}
                        value={this.props.value}
                        onChange={(e: any, value: any) => {
                            this.props.onChange(value.value);
                            if (this.changeTimer) {
                                clearTimeout(this.changeTimer);
                            }
                            // eslint-disable-next-line @typescript-eslint/no-misused-promises
                            this.changeTimer = window.setTimeout(() => this.props.onDone(value.value), 500);
                        }}
                    >
                        {this.props.formattedValue ? this.props.formattedValue : this.props.value}
                    </SlideStepper>
                )}
                {this.props.inputToggleText && (
                    <Collapsible
                        onCollapsibleHeadingClick={() => this.setState({ hideSlider: !this.state.hideSlider })}
                        // hide the ability to toggle back to slider control if the user inputs a value greater than max
                        // we must leave Collapsible rendered so that the labels stay correct
                        theme={{ display: this.props.value > this.props.max ? 'none' : 'inherit' }}
                    >
                        <CollapsibleHeading
                            labels={{
                                collapsed: this.props.inputToggleText,
                                expanded: 'Switch to slider control'
                            }}
                            data-cy={Selectors.PlanAhead.SLIDER_TOGGLE}
                            aria-label={
                                this.state.hideSlider
                                    ? `Switch to slider control for ${this.props.label}`
                                    : `${this.props.inputToggleText} for ${this.props.label}`
                            }
                        />
                    </Collapsible>
                )}
            </div>
        );
    }
}
